/* sp-ab: split-test runtime for the Sucker Punch + Buff Balm themes. Loaded SYNCHRONOUSLY in <head>, right after assets/sp-tests.js
   (the registry). It only decides who sees version B and switches B on; B itself is ordinary theme code the optimizer agents write.
   Everything is wrapped: registry missing, malformed, expired = nobody is assigned, no errors, everyone sees A.
   - Assignment: FNV-1a(test key + ":" + sp_vid) -> 0..99; B when < split. Same visitor = same version on every page and visit.
   - Never assigned (they see A, and are not counted): opted-out devices (sp_nt=1 / ?sp_notrack=1), test mode (?sp_tt=1), bots / automation, theme editor.
   - QA only: ?sp_ab=<key>:B (or :A) forces a version for 1 hour on this browser (cookie sp_abf) and is never counted. ?sp_ab=off clears it.
   - Effects for a visitor in a test, on pages the entry covers: <html class="sp-t-KEY-a|b" data-sp-t-KEY="A|B">. For B only: the entry's css files
     (parser-blocking <link>, so CSS-only variants paint right) and js files (deferred <script>) are loaded from this theme's assets folder.
   - sp-track.js (loaded later) reads window.__spAb.active, reports each assignment once per session and tags the Clarity session. */
(function(){
  "use strict";
  try {
    if (window.__spAb) return;
    var AB = window.__spAb = { v: 1, active: [], done: function(k){ try { var s = document.getElementById("sp-ab-hide-" + k); if (s && s.parentNode) s.parentNode.removeChild(s); } catch (e){} } };
    var reg = window.__spTests;
    if (Object.prototype.toString.call(reg) !== "[object Array]" || !reg.length) return;
    var me = document.currentScript, base = "";
    try { base = me && me.src ? me.src.replace(/[^\/]*$/, "").replace(/^\/\//, "https://") : ""; } catch (e){}
    var ck = function(n){ var m = document.cookie.match(new RegExp("(?:^|;\\s*)" + n + "=([^;]*)")); return m ? decodeURIComponent(m[1]) : ""; };
    var setCk = function(n, v, age){ document.cookie = n + "=" + encodeURIComponent(v) + "; path=/; max-age=" + age + "; SameSite=Lax" + (location.protocol === "https:" ? "; Secure" : ""); };
    var qs = location.search, qp = function(n){ var m = qs.match(new RegExp("[?&]" + n + "=([^&#]*)")); return m ? decodeURIComponent(m[1].replace(/\+/g, " ")) : null; };

    /* QA force list: "key:B,key2:A" */
    var f = qp("sp_ab");
    if (f === "off") setCk("sp_abf", "", 0);
    else if (f && /^[a-z0-9-]{3,40}:[AB](,[a-z0-9-]{3,40}:[AB])*$/.test(f)) setCk("sp_abf", f, 3600);
    var forced = {};
    ck("sp_abf").split(",").forEach(function(p){ var a = p.split(":"); if (a.length === 2 && (a[1] === "A" || a[1] === "B")) forced[a[0]] = a[1]; });

    var ttp = qp("sp_tt"), test = ttp === "1" || (ttp !== "0" && ck("sp_tt") === "1");
    var nt = qp("sp_notrack"), optedOut = nt === "1" || (nt !== "0" && ck("sp_nt") === "1");
    var bot = /bot|crawl|spider|headless|lighthouse/i.test(navigator.userAgent) || !!navigator.webdriver;
    var editor = !!(window.Shopify && window.Shopify.designMode);
    var countable = !test && !optedOut && !bot && !editor;
    if (!countable && !Object.keys(forced).length) return;

    var vid = ck("sp_vid");
    var needVid = function(){
      if (/^[a-z0-9]{20}$/.test(vid)) return;
      var a = "abcdefghijklmnopqrstuvwxyz0123456789", s = ""; for (var i = 0; i < 20; i++) s += a[Math.floor(Math.random() * a.length)];
      vid = s; setCk("sp_vid", vid, 31536000); /* the tracker reuses this id */
    };
    var hash = function(s){ var h = 2166136261; for (var i = 0; i < s.length; i++){ h ^= s.charCodeAt(i); h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0; } return h; };
    var path = location.pathname.length > 1 ? location.pathname.replace(/\/+$/, "") : "/";
    var onPage = function(pages){
      for (var i = 0; i < pages.length; i++){
        var p = pages[i]; if (typeof p !== "string") continue;
        if (p === "*" || p === path) return true;
        if (p.charAt(p.length - 1) === "*" && path.indexOf(p.slice(0, -1)) === 0) return true;
      }
      return false;
    };
    var now = Date.now(), root = document.documentElement;
    var assets = function(list, kind, key, hide){
      if (!base || Object.prototype.toString.call(list) !== "[object Array]") return;
      list.slice(0, 4).forEach(function(file){
        if (typeof file !== "string" || !/^[A-Za-z0-9][\w.-]{0,58}\.(css|js)$/.test(file) || file.slice(-kind.length) !== kind) return;
        var url = base + file + "?v=" + encodeURIComponent(String(rev));
        var html = kind === "css" ? '<link rel="stylesheet" href="' + url + '">'
          : '<script defer src="' + url + '"' + (hide ? ' onload="__spAb.done(\'' + key + '\')" onerror="__spAb.done(\'' + key + '\')"' : "") + "><\/script>";
        if (document.readyState === "loading") document.write(html);
        else { var el = document.createElement(kind === "css" ? "link" : "script"); if (kind === "css"){ el.rel = "stylesheet"; el.href = url; } else { el.src = url; el.async = false; } document.head.appendChild(el); }
      });
    };
    var rev = "";
    reg.slice(0, 6).forEach(function(t){
      try {
        if (!t || typeof t.key !== "string" || !/^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/.test(t.key)) return;
        if (Object.prototype.toString.call(t.pages) !== "[object Array]" || !onPage(t.pages)) return;
        var v, isForced = forced.hasOwnProperty(t.key);
        if (isForced) v = forced[t.key];
        else {
          if (!countable) return;
          var s = Date.parse(t.start), e = Date.parse(t.end);
          if (!(s <= now) || !(e > now)) return; /* not started, expired, or malformed dates */
          var split = +t.split; if (!(split >= 1 && split <= 99)) split = 50;
          needVid();
          v = hash(t.key + ":" + vid) % 100 < split ? "B" : "A";
        }
        root.className = (root.className ? root.className + " " : "") + "sp-t-" + t.key + "-" + v.toLowerCase();
        root.setAttribute("data-sp-t-" + t.key, v);
        AB.active.push({ k: t.key, v: v, counted: countable && !isForced });
        if (v === "B"){
          rev = t.rev || t.start || "";
          if (t.hide && typeof t.hide === "string" && t.hide.length < 200 && !/[<>{};]/.test(t.hide)){
            document.write('<style id="sp-ab-hide-' + t.key + '">' + t.hide + "{visibility:hidden!important}</style>");
            setTimeout(function(){ AB.done(t.key); }, 1500); /* never leave anything hidden */
          }
          assets(t.css, "css", t.key, false);
          assets(t.js, "js", t.key, !!t.hide);
        }
      } catch (e){}
    });
  } catch (err){}
})();
